<div class="step-container">
    <form [formGroup]="Form">
        <div id="es-form" class="form-content">
            <div class="currently-working">
                <div class="form-section mb-30">
                    <div class="mb-10">
                        <label class="label-question"> Are you currently working? </label>
                    </div>
                    <app-toggle-confirm-dialog  id="es-toggle-is-currently-working"
                                            #IsCurrentlyWorking
                                            formControlName="IsCurrentlyWorking"
                                            class="question-answer-input"
                                            (Change)="HandleMemberToggleEvent($event)"
                                            [ShowConfirmDialogForNO]="false"
                                            [ShowConfirmDialogForU]="true"
                                            [ShowButtonU]="false"
                                            [InputId]="'es-toggle-is-currently-working'"
                                            [InputName]="'IsCurrentlyWorking'">
                    </app-toggle-confirm-dialog>
                </div>
                <div *ngIf="ShowCurrentlyWorking" class="mb-30" >
                    <div class="inline-item">
                        <enterprise-text-input  id="es-input-name"
                                                Label="Your Name"
                                                [ErrorMessageOverride]="SetErrorTooltipMessage('Name', 'Your Name')"
                                                formControlName="Name"
                                                class="inline-form-input"
                                                [MaxLength]="NameMaxLength"
                                                [Appearance]="'outline'"
                                                [InputId]="'es-input-name'"
                                                [InputName]="'Name'">
                        </enterprise-text-input>
                        <enterprise-date-input  id="es-input-date"
                                                Label="Date last worked"
                                                formControlName="DateLastWorked"
                                                class="inline-form-input"
                                                [Hidden]="CurrentlyWorking"
                                                [Appearance]="'outline'"
                                                [InputId]="'es-input-date'"
                                                [InputName]="'DateLastWorked'">
                        </enterprise-date-input>
                    </div>
                    <div class="inline-item">
                        <enterprise-text-input  id="es-input-employer-name"
                                                [Label]="CurrentlyWorking ? 'Name of Current Employer' : 'Name of Former Employer'"
                                                formControlName="EmployerName"
                                                [ErrorMessageOverride]="SetErrorTooltipMessage('EmployerName', CurrentlyWorking ? 'Name of Current Employer' : 'Name of Former Employer')"
                                                class="inline-form-input"
                                                [MaxLength]="EmployerNameMaxLength"
                                                [Appearance]="'outline'"
                                                [InputId]="'es-input-employer-name'"
                                                [InputName]="'EmployerName'">
                        </enterprise-text-input>
                        <app-input-phone id="es-input-employer-phone"
                                         [Label]="CurrentlyWorking ? 'Current Employer #' : 'Former Employer #'"
                                         [Form]="Form"
                                         class="inline-form-input"
                                         [FormControlName]="'EmployerPhone'"
                                         [ButtonDisabled]="true"
                                         [ShowButton]="true"
                                         [InputId]="'es-input-employer-phone'"
                                         [InputName]="'EmployerPhone'">
                        </app-input-phone>
                    </div>
                </div>
            </div>
            <div class="spouse-currently-working">
                <div class="form-section mb-30" *ngIf="ShowSpouseCurrentlyWorkingQuestion">
                    <div class="mb-10">
                        <label class="label-question"> Is your spouse currently working? </label>
                    </div>
                    <app-toggle-confirm-dialog
                                            id="es-toggle-spouse-is-currently-working"
                                            #SpouseIsCurrentlyWorking
                                            formControlName="SpouseIsCurrentlyWorking"
                                            class="question-answer-input"
                                            (Change)="HandleSpouseToggleEvent($event)"
                                            [ConfirmDialogSubtitle]="'This will delete everything in this section.'"
                                            [ConfirmDialogMessage]="'Please confirm if you would like to proceed with this change.'"
                                            [ShowLabel]="false"
                                            [ShowConfirmDialogForNO]="false"
                                            [ShowConfirmDialogForU]="true"
                                            [SkipModalWithEmit]="SkipSpouseToggleU()"
                                            [ShowButtonU]="true"
                                            [InputId]="'es-toggle-spouse-is-currently-working'"
                                            [InputName]="'SpouseIsCurrentlyWorking'">
                    </app-toggle-confirm-dialog>
                </div>
                <div *ngIf="ShowSpouseCurrentlyWorking" class="mb-30" >
                    <div class="inline-item">
                        <enterprise-text-input  id="es-input-spouse-name"
                                                Label="Name of Spouse"
                                                [ErrorMessageOverride]="SetErrorTooltipMessage('SpouseName', 'Name of Spouse')"
                                                formControlName="SpouseName"
                                                class="inline-form-input"
                                                [MaxLength]="NameMaxLength"
                                                [Appearance]="'outline'"
                                                [InputId]="'es-input-spouse-name'"
                                                [InputName]="'SpouseName'">
                        </enterprise-text-input>
                        <enterprise-date-input  id="es-input-spouse-dlw"
                                                Label="Date last worked"
                                                formControlName="SpouseDateLastWorked"
                                                class="inline-form-input"
                                                [Hidden]="SpouseCurrentlyWorking"
                                                [Appearance]="'outline'"
                                                [InputId]="'es-input-spouse-dlw'"
                                                [InputName]="'SpouseDateLastWorked'">
                        </enterprise-date-input>
                    </div>
                    <div class="inline-item">
                        <enterprise-text-input  id="es-input-spouse-employer-name"
                                                [Label]="SpouseCurrentlyWorking ? 'Name of Current Employer' : 'Name of Former Employer'"
                                                formControlName="SpouseEmployerName"
                                                [ErrorMessageOverride]="SetErrorTooltipMessage('SpouseEmployerName', SpouseCurrentlyWorking ? 'Name of Current Employer' : 'Name of Former Employer')"
                                                class="inline-form-input"
                                                [MaxLength]="EmployerNameMaxLength"
                                                [Appearance]="'outline'"
                                                [InputId]="'es-input-spouse-employer-name'"
                                                [InputName]="'SpouseEmployerName'">
                        </enterprise-text-input>
                        <app-input-phone id="es-input-spouse-currently-working"
                                         [Label]="SpouseCurrentlyWorking ? 'Current Employer #' : 'Former Employer #'"
                                         [Form]="Form"
                                         class="inline-form-input"
                                         [FormControlName]="'SpouseEmployerPhone'"
                                         [ButtonDisabled]="true"
                                         [ShowButton]="true"
                                         [InputId]="'es-input-spouse-currently-working'"
                                         [InputName]="'SpouseEmployerPhone'">
                        </app-input-phone>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
